import { useEffect, useState } from "react";
import {
  LightModeOutlined,
  DarkModeOutlined,
  ArrowDropDownOutlined,
  Person,
  Logout,
  Info,
} from "@mui/icons-material";
import FlexBetween from "./FlexBetween";
import {
  Button,
  Box,
  Menu,
  MenuItem,
  Typography,
  ListItemIcon,
  ListItemText,
  Divider,
  Avatar,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import jwtDecode from "jwt-decode";
import jwt from "../services/jwt";



function MenuNav() {

    const [anchorEl, setAnchorEl] = useState(null);
    const isOpen = Boolean(anchorEl);
    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const [user, setUser] = useState();
    const navigate = useNavigate();

    const service = localStorage.getItem('project');

    useEffect(() => {
      const token = jwt.getToken();
      try {
            const decoded = jwtDecode(token);
            setUser(decoded);
      } catch (e) {
        console.error("[MenuNav] Error decoding token: ", e);
      }
    }, [])
    

    const handleLogout = () => {
        localStorage.clear("token");
        navigate("/");
        handleClose();
    };

    return (
    <FlexBetween gap="1.5rem">
          <FlexBetween>
            <Button
            color="neutral2"
              onClick={handleClick}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                textTransform: "none",
                gap: "1rem",
              }}>
                <Avatar>
              <Person
                ></Person>

                </Avatar>

              <Box textAlign="left">
                <Typography
                  fontWeight="bold"
                  fontSize="0.85rem"
                  >
                  {user?.nombre}
                </Typography>
                <Typography
                  fontSize="0.75rem"
                  >
                  {user?.sub}
                </Typography>
              </Box>
              <ArrowDropDownOutlined
              />
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={isOpen}
              onClose={handleClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              disableScrollLock={true}>
              {/* Aca abajo queda comentado el botón para modo oscuro para usarlo en algún momento */}
              {/* <MenuItem onClick={() => console.log("Click dark/light mode")}>
                <ListItemIcon>
                  {theme.palette.mode === "dark" ? (
                    <LightModeOutlined sx={{ fontSize: "25px" }} />
                  ) : (
                    <DarkModeOutlined sx={{ fontSize: "25px" }} />
                  )}
                </ListItemIcon>
                <ListItemText>
                  {theme.palette.mode === "dark" ? "Light Mode" : "Dark Mode"}
                </ListItemText>
              </MenuItem>
              <Divider></Divider> */}
              <MenuItem onClick={handleLogout}>
                <ListItemIcon>
                  <Logout />
                </ListItemIcon>
                <ListItemText>Log Out</ListItemText>
              </MenuItem>
              <Divider/>
              <MenuItem
                disabled
                dense={true}              >
                <ListItemIcon>
                  <Info />
                </ListItemIcon>
                <ListItemText>Servicio: {service}</ListItemText>
              </MenuItem>
            </Menu>
          </FlexBetween>
        </FlexBetween>
  )
}

export default MenuNav
